import axios from 'axios'

/**
 * The results-desk API.
 *
 * Kept separate from the portal client because a display signs in as match
 * staff, holds its own token, and must not be signed out by anything happening
 * in a coordinator session in another tab.
 */
const BASE = import.meta.env.VITE_API_BASE_URL || '/api'
const TOKEN_KEY = 'reporting_token'
const USER_KEY = 'reporting_user'

const client = axios.create({ baseURL: BASE })

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) config.headers.Authorization = `Bearer ${token}`
  config.headers['X-Original-Host'] = window.location.host
  return config
})

const get = (path, params) => client.get(path, { params }).then((r) => r.data)

export const reportingApi = {
  async login(username, password) {
    const res = await client.post('/scorer/login', { username, password })
    localStorage.setItem(TOKEN_KEY, res.data.access_token)
    localStorage.setItem(USER_KEY, JSON.stringify(res.data.scorer))
    return res.data.scorer
  },

  signedIn: () => !!localStorage.getItem(TOKEN_KEY),

  current() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || 'null')
    } catch {
      return null
    }
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  },

  // The drill-down: where the screen is, then what is on it.
  context: (params) => get('/scorer/board/context', params),
  city: (params) => get('/scorer/board/city', params),
  venue: (params) => get('/scorer/board/venue', params),
  court: (params) => get('/scorer/board/court', params),

  // Everything else.
  live: (params) => get('/scorer/board/live', params),
  results: (params) => get('/scorer/board/results', params),
  events: (params) => get('/scorer/board/events', params),
  scorecard: (id) => get(`/scorer/board/matches/${id}`),
  statSports: () => get('/scorer/board/stats/sports'),
  stats: (params) => get('/scorer/board/stats', params),
}

export default reportingApi
